// Danh sách tờ trình V2 — UI giữ nguyên như V1, đổi endpoint sang tk_request.
import { Link } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";
import Moment from "react-moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ListToTrinh from "../workflows/ListToTrinh";
import { checkRole } from "../model";
import { URL_LIST_ALL } from "../configs/api";
import Axios from "axios";
import { confirmAlert } from "react-confirm-alert";
import ModalFastViewV2 from "./components/ModalFastViewV2";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, LabelList } from "recharts";
import SearchBoxModal from "../component/SearchBoxModal";
import { groupStepsByPosition, EP, IDROLE, ROUTE } from "./constants/trinhKy";

export default function DanhSachToTrinhV2() {
  const [params, setParam] = useState("status=1");
  const [filterShow, setFilterShow] = useState(false);
  const [chartOnly, setChartOnly] = useState(false);
  const [chartGroup, setChartGroup] = useState(false);
  const [status, setStatus] = useState(1);
  const [wfID, setWFID] = useState("");
  const [code, setCode] = useState("");
  const [authorId, setAuthorID] = useState("");
  const [title, setTitle] = useState("");
  const { user } = useSelector((state) => state.auth);
  const idrole = IDROLE;
  const allowDelete = checkRole(user, idrole, "delete");
  const allowFastCheck = checkRole(user, idrole, "fastcheck");
  const allowStatistic = checkRole(user, idrole, "statistic");
  const allowStatisticGroup = checkRole(user, idrole, "statistic_group");
  const [dataChartOnly, setDataChartOnly] = useState(null);
  const [avgGroupData, setAvgGroupData] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const handleFastApproveSuccess = () => {
    window.location.reload();
  };

  const columns = [
    { name: "id", label: "ID", options: { filter: false, sort: true } },
    {
      name: "title", label: "Tiêu đề",
      options: { filter: false, sort: true, customBodyRender: (value) => value },
    },
    { name: "code", label: "Số Ttr", options: { filter: true, sort: true } },
    {
      name: "author_name", label: "Người tạo",
      options: {
        filter: false, sort: true,
        customBodyRender: (value, tableMeta) => (
          <div className="w-100">
            <strong>{value}</strong><br />
            <span className="far fa-clock"></span> {<Moment format="DD/MM/YYYY">{new Date(tableMeta.datecreate * 1000)}</Moment>}
          </div>
        ),
      },
    },
    {
      name: "workflow_steps", label: "Tiến trình",
      options: {
        filter: false, sort: true,
        customBodyRender: (value, tableMeta) => {
          if (!value) return null;
          const groupedList = groupStepsByPosition(value || []);
          const current_pos = tableMeta.position;
          const wf_status = tableMeta.status;
          return (
            <div className="list-tientrinh">
              <div className="row">
                {groupedList.map((group) => (
                  <div className="col-12 col-sm-6 mb-2 item-totrinh" key={group.position}>
                    <div className="wrapper bg-white border rounded shaddow">
                      <h5 className="text-center item-header pl-3 pr-3 pt-2 pb-2 border-bottom">
                        {group.position}. {group.group_name}
                      </h5>
                      <div className="w-100 pl-2 pr-2 pt-2 pb-2 info">
                        {group.member.map((m) => (
                          <div className="item-user" key={m.id}>
                            <div className="user-status">
                              <div className={(group.position == current_pos && m.action != 1 && wf_status == 1) ? "bg-success text-white pl-2 pr-2 pt-1 pb-1" : ""}>
                                <strong>{m.fullname}</strong>
                                {(group.position == current_pos && m.action != 1 && wf_status == 1 && user.data.id == m.user_id) ? <span className="ml-2 fas fa-flag-checkered"></span> : ""}
                              </div>
                              {(tableMeta.status != 4 || m.action == 4) && (
                                <div className="check_status">
                                  {m.action == 1 && (<p className="text-success"><span className="fas fa-check-circle"></span><i className="ml-1"> Đã duyệt</i></p>)}
                                  {m.action == 2 && (<p className="text-info"><span className="fas fa-times-circle"></span><i className="ml-1"> Yêu cầu bổ sung</i></p>)}
                                  {m.action == 3 && (<p className="text-danger"><span className="fas fa-times-circle"></span><i className="ml-1"> Trả về</i></p>)}
                                  {m.action == 4 && (<p className="text-danger"><span className="fas fa-times-circle"></span><i className="ml-1"> Hủy bỏ</i></p>)}
                                  {m.action == 5 && (<p className="text-secondary"><span className="far fa-question-circle"></span><i className="ml-1"> Xin ý kiến</i></p>)}
                                  {m.action == 0 && (<p className="text-warning"><span className="fas fa-clock"></span><i className="ml-1"> Chờ ký</i></p>)}
                                  {m.timecheck && <small><span className="far fa-clock"></span><Moment format="H:mm DD/MM/YYYY">{m.timecheck}</Moment></small>}
                                </div>
                              )}
                            </div>
                            {m.note_comment && (
                              <div className="w-100">
                                <i className="far fa-comment-dots"></i><small style={{ whiteSpace: "pre-line" }}> {m.note_comment}</small>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "status", label: "Trạng thái",
      options: {
        filter: false, sort: true,
        customBodyRender: (value) => {
          if (value == 1) return <span className="text-info">Chưa hoàn tất</span>;
          if (value == 2) return <span className="text-success">Đã được duyệt</span>;
          if (value == 4) return <span className="text-danger">Đã bị hủy</span>;
        },
      },
    },
    {
      name: "action", label: "Thao tác",
      options: {
        filter: false, sort: true,
        customBodyRender: (value, tableMeta) => {
          let view = null;
          let del = null;
          const workflow_steps = tableMeta.workflow_steps;
          const current_pos = tableMeta.position;
          const listPreview = tableMeta.file_preview;
          const isMyTurn = workflow_steps.find((step) => step.user_id === user.data.id && step.position === current_pos);
          const myStepId = isMyTurn ? isMyTurn.id : null;
          let fastview = "";
          if (((allowFastCheck && isMyTurn) || user.data.id == 1) && listPreview) {
            fastview = (<><p>{value}</p><br /><ModalFastViewV2 detail={tableMeta} idstep={myStepId} onSuccess={handleFastApproveSuccess} /></>);
          }
          if (tableMeta.status == 2 || tableMeta.status == 4) {
            view = (<div className="col-6 col-sm-12"><a className="btn btn-sm btn-warning text-white w-100 mt-1" href={ROUTE.publicView(tableMeta.hash_code)}><span className="fas fa-eye"></span> Xem</a></div>);
          } else {
            view = (<div className="col-6 col-sm-12"><a className="btn btn-sm btn-warning text-white w-100 mt-1" href={ROUTE.edit(tableMeta.id)}><span className="fas fa-eye"></span> {tableMeta.author_id == user.data.id ? "Sửa" : "Xem"}</a></div>);
            if (allowDelete) {
              del = (<div className="col-6 col-sm-12"><button className="btn btn-sm btn-danger text-white w-100 mt-1" type="button" onClick={() => onDelete(tableMeta.id)}><span className="fas fa-trash-alt"></span> Xóa</button></div>);
            }
          }
          return <div className="row justify-content-center">{fastview}{view}{del}</div>;
        },
      },
    },
  ];

  const onDelete = (tr_id) => {
    confirmAlert({
      title: "Cảnh báo !!!",
      message: "Bạn đang thực hiện thao tác xóa tờ trình",
      buttons: [
        {
          label: "Có",
          onClick: () => {
            Axios.delete(URL_LIST_ALL + EP.request + "/" + tr_id, user.config)
              .then((res) => {
                if (res.data.status === "success") setRefresh(res.data.time);
                else alert(res.data.message);
              })
              .catch((err) => console.log(err));
          },
        },
        { label: "Không" },
      ],
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let _param = "";
    if (status && status !== "") _param += "&status=" + status;
    if (code && code !== "") _param += "&code=" + code;
    if (title && title !== "") _param += "&title=" + title;
    if (wfID && wfID !== "") _param += "&id=" + wfID;
    if (authorId && authorId !== "") _param += "&author_id=" + authorId;
    setParam(_param);
  };

  useEffect(
    function () {
      if (allowStatistic) {
        let mounted = true;
        Axios.get(URL_LIST_ALL + "bieudototrinh_canhan?user_id=" + user.data.id, user.config)
          .then((res) => {
            if (res.data.status === "success" && mounted) {
              setDataChartOnly(res.data.data || null);
              setAvgGroupData(res.data.avg || null);
            }
          })
          .catch((err) => console.log(err));
        return () => (mounted = false);
      }
    },
    [user, allowStatistic]
  );

  const renderYAxisTick = ({ x, y, payload }) => {
    const lines = payload.value.split("\n");
    return (
      <text x={x} y={y} textAnchor="end" fill="#666">
        {lines.map((line, index) => (
          <tspan key={index} x={x} dy={index === 0 ? 0 : 20} fontWeight={index === 0 ? 600 : 400}>{line}</tspan>
        ))}
      </text>
    );
  };

  const renderChart = (chartData, dv = "") => {
    const maxValue = Math.ceil(Math.max(...chartData.map((i) => i.value)) * 1.1);
    return (
      <ResponsiveContainer>
        <BarChart layout="vertical" data={chartData} margin={{ top: 10, right: 20, left: 10, bottom: 20 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" domain={[0, maxValue]} allowDecimals={false} tickFormatter={(v) => `${v} ${dv}`} />
          <YAxis type="category" dataKey="name" width={140} tick={renderYAxisTick} />
          <Tooltip />
          <Bar dataKey="value" barSize={30} background={{ fill: "#e5e7eb" }} radius={[0, 8, 8, 0]}>
            {chartData.map((entry, index) => (<Cell key={`cell-${index}`} fill={entry.color} />))}
            <LabelList dataKey="value" position="right" style={{ fill: "#111", fontWeight: 600, fontSize: 11 }} formatter={(v) => `${v} ${dv}`} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  };

  return (
    <AkkhorLayout idrole="workflow_walking">
      <div className="breadcrumbs-area">
        <ul>
          <li><Link to="/">Trang chủ</Link></li>
          <li>Tờ trình</li>
        </ul>
      </div>
      <div className="card card-filter mb-3">
        <div className="card-header">
          <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
            <div className="mr-auto"><h3 className="title">Tìm kiếm</h3></div>
            <button className="btn btn-sm btn-defaul"><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
          </div>
        </div>
        <div className={filterShow ? "card-body" : "hidden-filter"}>
          <form className="new-added-form" method="get">
            <div className="row">
              {(user.data.code == "MS000185" || user.data.code == "MS00092" || user.data.code == "MS000005") && (
                <div className="col-lg-3 col-12 form-group">
                  <label>ID tờ trình</label>
                  <input placeholder="Nhập ID tờ trình..." type="input" className="form-control" value={wfID} onChange={(e) => setWFID(e.target.value)} />
                </div>
              )}
              <div className="col-lg-3 col-12 form-group">
                <label>Trạng thái phê duyệt</label>
                <select className="form-select height32" value={status} onChange={(e) => setStatus(e.target.value)}>
                  <option value="all">Tất cả</option>
                  <option value="2">Đã được duyệt</option>
                  <option value="1">Chưa hoàn thành</option>
                  <option value="4">Hủy bỏ</option>
                </select>
              </div>
              <div className="col-lg-3 col-12 form-group">
                <label>Số tờ trình</label>
                <input placeholder="Nhập số tờ trình..." type="input" className="form-control" value={code} onChange={(e) => setCode(e.target.value)} />
              </div>
              <div className="col-lg-3 col-12 form-group">
                <label>Tiêu đề</label>
                <input placeholder="Tìm theo tiêu đề..." type="input" className="form-control" value={title} onChange={(e) => setTitle(e.target.value)} />
              </div>
              <div className="col-12 col-sm-3 form-group">
                <label>Người tạo</label>
                <SearchBoxModal apiname={"users"} placeholder="Người cấp số" colvalue={"id"} colname={"fullname"} defaultValue={authorId} name="approve_id" onChange={async (e) => setAuthorID(e)}></SearchBoxModal>
              </div>
              <div className="col-12">
                <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="row">
        {allowStatistic && (
          <div className="col-12 col-sm-6">
            <div className="card card-filter mb-3">
              <div className="card-header">
                <div className="d-flex" onClick={() => setChartOnly(!chartOnly)}>
                  <div className="mr-auto"><h3 className="title">Báo cáo hôm nay</h3></div>
                  <button className="btn btn-sm btn-defaul"><span className={!chartOnly ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
                </div>
              </div>
              <div className={chartOnly ? "card-body" : "hidden-filter"}>
                {dataChartOnly && (<div style={{ width: "100%", height: 300 }}>{renderChart(dataChartOnly, "TTr")}</div>)}
              </div>
            </div>
          </div>
        )}
        {allowStatisticGroup && (
          <div className="col-12 col-sm-6">
            <div className="card card-filter mb-3">
              <div className="card-header">
                <div className="d-flex" onClick={() => setChartGroup(!chartGroup)}>
                  <div className="mr-auto"><h3 className="title">Thời gian xử lý trung bình</h3></div>
                  <button className="btn btn-sm btn-defaul"><span className={!chartOnly ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
                </div>
              </div>
              <div className={chartGroup ? "card-body" : "hidden-filter"}>
                {avgGroupData && (<div style={{ width: "100%", height: 300 }}>{renderChart(avgGroupData, "giờ")}</div>)}
              </div>
            </div>
          </div>
        )}
      </div>
      <ListToTrinh name={EP.request} refresh={refresh} idrole={idrole} linkaction="workflow_walking" params={params} title="" defaultLimit={20} serverSide={true} columns={columns}></ListToTrinh>
    </AkkhorLayout>
  );
}
